(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/forms')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/common', '@angular/forms'], factory) :
	(factory((global['soft-angular-mask'] = {}),global._angular_core,global._angular_common,global._angular_forms));
}(this, (function (exports,_angular_core,_angular_common,_angular_forms) { 'use strict';

var MASK = {
    provide: _angular_forms.NG_VALUE_ACCESSOR,
    useExisting: _angular_core.forwardRef(function () { return MaskNumberDirective; }),
    multi: true
};
var MaskNumberDirective = (function () {
    /**
     * @param {?} renderer
     * @param {?} element
     */
    function MaskNumberDirective(renderer, element) {
        this.renderer = renderer;
        this.element = element;
        this.maskkOutput = false;
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    MaskNumberDirective.prototype.writeValue = function (value) {
        if (value === undefined || value === null) {
            this.propagateChange(null);
            this.renderer.setElementProperty(this.element.nativeElement, 'value', '');
        }
        else {
            this.input(value);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaskNumberDirective.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaskNumberDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} val
     * @param {?=} event
     * @return {?}
     */
    MaskNumberDirective.prototype.input = function (val, event) {
        var /** @type {?} */ mascared = '';
        var /** @type {?} */ unmask = val.toString().replace(new RegExp(/[^\d]/, 'g'), '');
        var /** @type {?} */ c = 0;
        for (var /** @type {?} */ i = 0; (i < this.mascara.length) && (c < unmask.length); i++) {
            if (this.mascara.slice(i, i + 1) == '9') {
                mascared += unmask.slice(c, c + 1);
                c++;
            }
            else {
                mascared += this.mascara.slice(i, i + 1);
            }
        }
        this.propagateChange((this.maskkOutput) ? mascared : mascared.replace(new RegExp(/[^\d]/, 'g'), ''));
        this.renderer.setElementProperty(this.element.nativeElement, 'value', mascared);
        setTimeout(function () {
            if (event !== undefined)
                event.setSelectionRange(mascared.length, mascared.length);
        }, 0);
    };
    /**
     * @return {?}
     */
    MaskNumberDirective.prototype.focusout = function () {
        this.onTouched();
        var /** @type {?} */ valCurrentField = (this.element.nativeElement.value == undefined) ? '' : this.element.nativeElement.value;
        if (typeof this.qtdRequiredMin !== 'undefined' && valCurrentField.length < this.qtdRequiredMin) {
            this.propagateChange(null);
            this.renderer.setElementProperty(this.element.nativeElement, 'value', '');
        }
        else if (typeof this.qtdRequiredMin === 'undefined' && valCurrentField.length != this.mascara.length) {
            this.propagateChange(null);
            this.renderer.setElementProperty(this.element.nativeElement, 'value', '');
        }
    };
    return MaskNumberDirective;
}());
MaskNumberDirective.decorators = [
    { type: _angular_core.Directive, args: [{
                selector: '[mask-number]',
                host: {
                    '(input)': 'input($event.target.value, $event.target)',
                    '(blur)': 'focusout()'
                },
                providers: [MASK]
            },] },
];
/**
 * @nocollapse
 */
MaskNumberDirective.ctorParameters = function () { return [
    { type: _angular_core.Renderer, decorators: [{ type: _angular_core.Inject, args: [_angular_core.Renderer,] },] },
    { type: _angular_core.ElementRef, decorators: [{ type: _angular_core.Inject, args: [_angular_core.ElementRef,] },] },
]; };
MaskNumberDirective.propDecorators = {
    'mascara': [{ type: _angular_core.Input, args: ['mask',] },],
    'qtdRequiredMin': [{ type: _angular_core.Input, args: ['reqMin',] },],
    'maskkOutput': [{ type: _angular_core.Input, args: ['maskkOutput',] },],
};

var MONEY = {
    provide: _angular_forms.NG_VALUE_ACCESSOR,
    useExisting: _angular_core.forwardRef(function () { return MaskMoneyDirective; }),
    multi: true
};
var MaskMoneyDirective = (function () {
    /**
     * @param {?} renderer
     * @param {?} element
     */
    function MaskMoneyDirective(renderer, element) {
        this.renderer = renderer;
        this.element = element;
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    MaskMoneyDirective.prototype.writeValue = function (value) {
        if (value === undefined || value === null) {
            this.propagateChange(null);
            this.renderer.setElementProperty(this.element.nativeElement, 'value', '');
        }
        else {
            value = value.toString().split(".");
            if (typeof value[1] == 'undefined') {
                value = value[0] + '.00';
            }
            else if (value[1].length == 1) {
                value = value[0] + '.' + value[1] + '0';
            }
            else if (value[1].length == 2) {
                value = value[0] + '.' + value[1];
            }
            else if (value[1].length > 2) {
                value = value[0] + '.' + value[1].slice(0, 2);
            }
            this.input(value);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaskMoneyDirective.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaskMoneyDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} val
     * @param {?=} event
     * @return {?}
     */
    MaskMoneyDirective.prototype.input = function (val, event) {
        if (val === '0') {
            this.propagateChange('0');
            this.renderer.setElementProperty(this.element.nativeElement, 'value', this.prefix + ' 0,00');
            return true;
        }
        var /** @type {?} */ unmask = val.toString().replace(new RegExp(/[^\d]/, 'g'), '').replace(/^0+/, '');
        if (unmask.length == 0) {
            this.propagateChange(null);
            this.renderer.setElementProperty(this.element.nativeElement, 'value', '');
            return true;
        }
        if (unmask.length == 1)
            unmask = '00' + unmask;
        if (unmask.length == 2)
            unmask = '0' + unmask;
        var /** @type {?} */ dec = unmask.slice(unmask.length - 2, unmask.length);
        var /** @type {?} */ mil = unmask.slice(0, unmask.length - 2);
        var /** @type {?} */ cont = 0;
        var /** @type {?} */ ref = '';
        for (var /** @type {?} */ i = mil.length; i > 0; i--) {
            if (cont == 2 && i > 1) {
                ref = '.' + mil.slice(i - 1, i) + ref;
                cont = 0;
            }
            else {
                ref = mil.slice(i - 1, i) + ref;
                cont++;
            }
        }
        var /** @type {?} */ mascared = this.prefix + ' ' + ref + ',' + dec;
        this.propagateChange(mil + '.' + dec);
        this.renderer.setElementProperty(this.element.nativeElement, 'value', mascared);
        setTimeout(function () {
            if (event !== undefined)
                event.setSelectionRange(mascared.length, mascared.length);
        }, 0);
    };
    return MaskMoneyDirective;
}());
MaskMoneyDirective.decorators = [
    { type: _angular_core.Directive, args: [{
                selector: '[mask-money]',
                host: {
                    '(input)': 'input($event.target.value, $event.target)',
                    '(blur)': 'onTouched($event)',
                },
                providers: [MONEY]
            },] },
];
/**
 * @nocollapse
 */
MaskMoneyDirective.ctorParameters = function () { return [
    { type: _angular_core.Renderer, decorators: [{ type: _angular_core.Inject, args: [_angular_core.Renderer,] },] },
    { type: _angular_core.ElementRef, decorators: [{ type: _angular_core.Inject, args: [_angular_core.ElementRef,] },] },
]; };
MaskMoneyDirective.propDecorators = {
    'prefix': [{ type: _angular_core.Input, args: ['prefix',] },],
};

var MaskModule = (function () {
    function MaskModule() {
    }
    /**
     * @return {?}
     */
    MaskModule.forRoot = function () {
        return {
            ngModule: MaskModule
        };
    };
    return MaskModule;
}());
MaskModule.decorators = [
    { type: _angular_core.NgModule, args: [{
                imports: [
                    _angular_common.CommonModule
                ],
                declarations: [
                    MaskNumberDirective,
                    MaskMoneyDirective
                ],
                exports: [
                    MaskNumberDirective,
                    MaskMoneyDirective
                ]
            },] },
];
/**
 * @nocollapse
 */
MaskModule.ctorParameters = function () { return []; };

exports.MaskModule = MaskModule;
exports.MASK = MASK;
exports.MaskNumberDirective = MaskNumberDirective;
exports.MONEY = MONEY;
exports.MaskMoneyDirective = MaskMoneyDirective;

Object.defineProperty(exports, '__esModule', { value: true });

})));
